const actions = [
  { icon: 'ri-megaphone-line', title: 'Объяснять', desc: 'Что меняется и почему — понятно и своевременно, без скрытия причин.' },
  { icon: 'ri-alert-line', title: 'Показывать последствия', desc: 'Что произойдёт, если компания ничего не изменит, и почему оставаться на месте нельзя.' },
  { icon: 'ri-focus-3-line', title: 'Формировать понятные ожидания', desc: 'Что конкретно должен делать каждый сотрудник после изменения.' },
  { icon: 'ri-headphone-line', title: 'Слушать', desc: 'Выявлять реальные опасения и проблемы команды, а не игнорировать их.' },
  { icon: 'ri-graduation-cap-line', title: 'Обучать', desc: 'Давать людям необходимые навыки для работы по-новому.' },
  { icon: 'ri-heart-line', title: 'Поддерживать', desc: 'Помогать проходить сложный переходный период без чувства брошенности.' },
  { icon: 'ri-dashboard-line', title: 'Контролировать', desc: 'Следить не только за фактом выполнения, но и за качеством внедрения.' },
  { icon: 'ri-anchor-line', title: 'Закреплять', desc: 'Превращать новое поведение в стандарт, который закреплён в процессах и контроле.' },
];

export default function ManagerRole() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Роль руководителя в период изменений
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Что должен делать руководитель, чтобы изменения действительно прижились, а не остались декларацией
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {actions.map((a) => (
            <div key={a.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${a.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{a.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}